module.exports = __webpack_public_path__ + "static/media/home_top_app.bddf2535.png";